module.exports = __webpack_public_path__ + "static/img/left.3ab10d4d.png";